import styles from './ErrorPage.module.scss';
import { useTranslation } from 'react-i18next';

interface ErrorPageProps {
  title: string;
  subtitle: string;
  onClick?: () => void;
}

export const ErrorPage = ({ title, subtitle }: ErrorPageProps) => {

  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.body_container}>
        <h2 className={styles.title}>{t(title)}</h2>
        <div className={styles.divider}></div>
        <h5 className={styles.subtitle}>{t(subtitle)}</h5>
      </div>
    </div>
  );
};
